import { format } from 'date-fns';
import type { DataTableColumn } from '@/components/custom/erp';
import { TyGiaQuyDoiNgoaiTe } from '@/types/schemas';

export const getDataTableColumns = (): DataTableColumn<TyGiaQuyDoiNgoaiTe>[] => {
  return [
    {
      field: 'ma_nt',
      headerName: 'Mã ngoại tệ',
      width: 150,
      renderCell: params => {
        return params.row.ma_nt_data?.ma_nt;
      }
    },
    {
      field: 'ten_nt',
      headerName: 'Tên ngoại tệ',
      width: 200,
      renderCell: params => {
        return params.row.ma_nt_data?.ten_nt;
      }
    },
    {
      field: 'ngay_hl',
      headerName: 'Ngày',
      width: 150,
      renderCell: params => {
        return format(params.row.ngay_hl, 'dd/MM/yyyy');
      }
    },
    {
      field: 'ty_gia',
      headerName: 'Tỷ giá',
      width: 150,
      renderCell: params => {
        return params.row.ty_gia;
      }
    }
  ];
};
